import React, { useEffect, useState } from "react";
import { Table, Form, Breadcrumb, Button, Spinner, Modal, FormGroup } from "react-bootstrap";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import axios from "axios";
import { faComments, faEdit, faPlus, faSave, faTimes, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLOR_APP, COLOR_APP_CANCEL, S3_URL } from "../../constants";
import { useToasts } from "react-toast-notifications";
import { v4 as uuidv4 } from "uuid";
// import { GET_SETTINGS } from "../../graphql/setting/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { CREATE_SETTING, UPDATE_SETTING } from "../../graphql/setting/mutation";
import { GET_PRESIGN_URL } from "../../graphql/presignUrl/query";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { GET_BANKS } from "../../graphql/bank/query";
import { CREATE_BANK, DELETE_BANK, UPDATE_BANK } from "../../graphql/bank/mutation";
import BasicModal from "../../components/BasicModal";
import EmptyComponent from "../../components/EmptyComponent";
// import AnimationLoading from "../../components/AnimationLoading";
import LoadingSpinner from "../../components/LoadingSpinner";
import BankAccountActive from "./BankAccountActive";
import { FaCheckSquare } from "react-icons/fa";


function SettingsBank() {
  const { addToast } = useToasts();
  const { history } = useReactRouter();

  const [shopSettings, setShopSettings] = useState([]);
  const [bankName, setBankName] = useState();
  const [selectedBankCode, setSelectedBankCode] = useState("BCEL");
  const [bankAccount, setBankAccount] = useState();
  const [bankUser, setBankUser] = useState();
  const [selectedPaymentCard, setSelectedPaymentCard] = useState("UNIONPAY");
  const [selectedCurrency, setSelectedCurrency] = useState("LAK");
  const [existingImageUrl, setExistingImageUrl] = useState("");
  const [bankDatas, setBankDatas] = useState([]);
  const [file, setFile] = useState();
  const [imageLoading, setImageLoading] = useState(0);
  const [fileName, setFileName] = useState();
  const [isLoading, setIsLoading] = useState();
  const [isEdited, setIsEdited] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDefaultModal, setIsDefaultModal] = useState(false);

  // const bankList = [
  //   'ທະນາຄານການຄ້າຕ່າງປະເທດລາວ ມະຫາຊົນ',
  //   'ທະນາຄານພັດທະນາລາວ',
  //   'ທະນາຄານຮ່ວມພັດທະນາ',
  //   'ທະນາຄານສົ່ງເສີມກະສິກຳ',
  //   'ທະນາຄານລາວ - ຫວຽດ',
  //   'ທະນາຄານພົງສະຫວັນ',
  //   'ທະນາຄານ ເອຊີລີດ້າ']

  const bankListV2 =
    {
    'BCEL': 'ທະນາຄານການຄ້າຕ່າງປະເທດລາວ ມະຫາຊົນ',
    'LDB': 'ທະນາຄານພັດທະນາລາວ',
    'JDB': 'ທະນາຄານຮ່ວມພັດທະນາ',
    'APB': 'ທະນາຄານສົ່ງເສີມກະສິກຳ',
    'LVB': 'ທະນາຄານລາວ - ຫວຽດ',
    'PSV': 'ທະນາຄານພົງສະຫວັນ',
    'ACLEDA': 'ທະນາຄານ ເອຊີລີດ້າ',
    'INDOCHINA_BANK': 'ທະນາຄານ ອີນໂດຈີນ'
  }
  const paymentCard = ['MASTERCARD', 'UNIONPAY', 'VISA', 'VIRTUAL']
  const currency = ['LAK', 'THB', 'USD']

  const [getBank, { data: bankData, loading }] = useLazyQuery(GET_BANKS, {
    fetchPolicy: "cache-and-network",
  });
  const [createSetting] = useMutation(CREATE_SETTING);
  const [updateSetting] = useMutation(UPDATE_SETTING);
  const [createBank, { loading: createLoading }] = useMutation(CREATE_BANK);
  const [updateBank, { loading: updateLoading }] = useMutation(UPDATE_BANK);
  const [deleteBank, { loading: deleteLoading }] = useMutation(DELETE_BANK);

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  useEffect(() => {
    // initSetting();
    _getBank();
    // Set default bank name when component mounts
    setBankName(bankListV2["BCEL"]);
  }, []);

  useEffect(() => {
    if (bankData?.banks) return setBankDatas(bankData?.banks?.data);
  }, [bankData]);


  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  // Auto-set currency to USD when VISA or MASTERCARD is selected
  useEffect(() => {
    if (selectedPaymentCard === 'VISA' || selectedPaymentCard === 'MASTERCARD') {
      setSelectedCurrency('USD');
    }
  }, [selectedPaymentCard]);

  const _getBank = async () => {
    try {
      let SHOP_ID = await localStorage.getItem("SHOP");
      await getBank({
        variables: {
          where: {
            shop: SHOP_ID,
            isDeleted: false
          },
          skip: 0,
          limit: 100,
          orderBy: "createdAt_DESC"
        },
      });
      return;
    } catch (err) {
      console.log(err)
    }
  }

  const _createBank = async () => {
    try {
      if (createLoading) return;
      if (!bankUser) return addToast("ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້ບັນຊີ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!bankAccount) return addToast("ກະລຸນາປ້ອນເລກບັນຊີ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!selectedBankCode) return addToast("ກະລຸນາເລືອກທະນາຄານ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!selectedPaymentCard) return addToast("ກະລຸນາເລືອກປະເພດບັດ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!selectedCurrency) return addToast("ກະລຸນາເລືອກສະກຸນເງິນ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      await createBank(
        {
          variables: {
            data: {
              bankAccount: bankAccount,
              bankName: bankListV2[selectedBankCode], // Save the bank code (label) instead of full name
              bankAbbv: selectedBankCode,
              bankUser: bankUser,
              image: fileName,
              paymentCard: selectedPaymentCard,
              currency: selectedCurrency,
            }
          }
        }
      )
      _clearData();
      _getBank();
      setShowAddModal(false);
    } catch (err) {
      console.log(err)
      if (err.message === "BAD_REQUEST") return addToast("ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບກ່ອນ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (err.message === "ACCOUNT_ALREADY_EXIST") return addToast("ບັນຊີນີິມີຢູ່ແລ້ວ", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  }

  const _updateBank = async () => {
    try {
      if (updateLoading) return;
      if (!bankUser) return addToast("ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້ບັນຊີ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!bankAccount) return addToast("ກະລຸນາປ້ອນເລກບັນຊີ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!selectedBankCode) return addToast("ກະລຸນາເລືອກທະນາຄານ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!selectedPaymentCard) return addToast("ກະລຸນາເລືອກປະເພດບັດ!", {
        appearance: "warning",
        autoDismiss: true,
      });
      if (!selectedCurrency) return addToast("ກະລຸນາເລືອກສະກຸນເງິນ!", {
        appearance: "warning",
        autoDismiss: true,
      });

      let imageToSave = existingImageUrl; // Default to existing image

      // If there's a new file selected, upload it to S3 first
      if (file) {
        try {
          var ext = file.name.split(".").pop();
          let newFileName = uuidv4() + "." + ext;
          
          // Get presign URL for the new file
          const presignResult = await getPresignUrl({
            variables: {
              name: newFileName,
            },
          });
          
          // Upload file to S3 using the presign URL
          if (presignResult.data?.preSignedUrl?.url) {
            await axios.put(presignResult.data.preSignedUrl.url, file, {
              headers: {
                "Content-Type": "file/*; image/*",
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              },
            });
            imageToSave = newFileName;
          }
        } catch (uploadError) {
          console.log("File upload error:", uploadError);
          return addToast("ເກີດຂໍ້ຜິດພາດໃນການອັບໂຫລດຮູບພາບ!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      }

      await updateBank(
        {
          variables: {
            data: {
              bankAccount: bankAccount,
              bankName: bankListV2[selectedBankCode], // Save the bank code (label) instead of full name
              bankAbbv: selectedBankCode,
              bankUser: bankUser,
              image: imageToSave,
              paymentCard: selectedPaymentCard,
              currency: selectedCurrency,
            },
            where: {
              id: selectedBankId
            }
          }
        }
      )
      _clearData();
      _getBank();
      setShowEditModal(false);
    } catch (err) {
      console.log(err)
      if (err.message === "BAD_REQUEST") return addToast("ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບກ່ອນ!", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  }

  const _deleteBank = async () => {
    try {
      if (deleteLoading) return;
      await deleteBank(
        {
          variables: {
            where: {
              id: selectedBankId
            }
          }
        }
      )
      _clearData();
      _getBank();
      setShowDeleteModal(false);
    } catch (err) {
      console.log(err)
    }
  }

  // const _saveSetting = async () => {
  //   if (isLoading) return;
  //   setIsLoading(true);
  //   const SHOP_ID = await localStorage.getItem("SHOP");
  //   const _bankDatas = {
  //     bankName,
  //     bankAccount,
  //     bankUser,
  //   };

  //   if (shopSettings.length <= 0) {
  //     await createSetting({
  //       variables: {
  //         data: {
  //           bank: JSON.stringify(_bankDatas),
  //           bankQr: fileName,
  //           shop: SHOP_ID,
  //         },
  //       },
  //     });
  //     setIsLoading(false);
  //     addToast("ຕັ້ງຄ່າທະນາຄານສໍາເລັດ", {
  //       appearance: "success",
  //       autoDismiss: true,
  //     });
  //   } else {
  //     await updateSetting({
  //       variables: {
  //         where: {
  //           id: shopSettings.id,
  //         },
  //         data: {
  //           bank: JSON.stringify(_bankDatas),
  //           bankQr: fileName,
  //           shop: SHOP_ID,
  //         },
  //       },
  //     });
  //     setIsLoading(false);
  //     addToast("ຕັ້ງຄ່າທະນາຄານສໍາເລັດ", {
  //       appearance: "success",
  //       autoDismiss: true,
  //     });
  //   }
  // };

  const ImageThumb = ({ image, height, width }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        // style={{
        //   objectFit: "cover",
        //   borderRadius: 8,
        //   height: height ?? 30,
        //   width: width ?? 30,
        // }}
        style={{ objectFit: "contain", width: "100%", height: "100%", maxHeight: "400px" }}
      />
    );
  };

  const handleUpload = async (event) => {
    setImageLoading(0);

    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);

      // if (shopSettings.length > 0) {
      //   await updateSetting({
      //     variables: {
      //       where: {
      //         id: shopSettings.id,
      //       },
      //       data: {
      //         bankQr: filename,
      //       },
      //     },
      //   });
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        const uploadfile = await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        // console.log("uploadfile: ", uploadfile);
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  const _clearData = () => {
    setBankAccount("");
    setBankName("");
    setSelectedBankCode("BCEL");
    setBankUser("");
    setSelectedPaymentCard("UNIONPAY");
    setSelectedCurrency("LAK");
    setSelectedBankId("");
    setIsEdited(false);
    setFileName();
    setFile();
    setExistingImageUrl("");
  }

  const { width, height } = useWindowDimensions();

  const onSelectBank = (bankCode) => {
    setSelectedBankCode(bankCode);
    setBankName(bankListV2[bankCode]);
  }

  const onSelectPaymentCard = (card) => {
    setSelectedPaymentCard(card);
    // Automatically set currency to USD for VISA and MASTERCARD
    if (card === 'VISA' || card === 'MASTERCARD') {
      setSelectedCurrency('USD');
    }
  }

  const handleCloseModalSetdefault = () => {
    setIsDefaultModal(false)
  }

  if (loading) return <LoadingSpinner />

  return (
    <div>
      <div>
        {width > 700 ? <Breadcrumb>
          <Breadcrumb.Item onClick={() => history.replace("/settings")}>
            ຕັ້ງຄ່າ
          </Breadcrumb.Item>
          <Breadcrumb.Item active>ບັນຊີທະນາຄານ</Breadcrumb.Item>
        </Breadcrumb> : <div style={{ height: 20 }} />}
        <div style={{ height: 10 }} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3 style={{ color: "#616161" }}>
            <FontAwesomeIcon icon={faComments} /> ຕັ້ງຄ່າບັນຊີທະນາຄານ
          </h3>
          <div>
            <Button onClick={() => setIsDefaultModal(true)} className="mr-2">ຕັ້ງຄ່າເລິ່ມຕົ້ນ</Button>
            {width > 700 && <Button onClick={() => {
              _clearData();
              setShowAddModal(true);
            }} style={{ background: COLOR_APP }}>ເພີ່ມບັນຊີທະນາຄານ
            </Button>}
          </div>
        </div>
        <div style={{ height: 20 }} />
        <div className="row">
          <div style={{ padding: 20 }}>
            <Table responsive>
              <thead>
                <tr style={{ whiteSpace: 'nowrap' }}>
                  <th style={{ borderBottom: 'none' }}>ລ/ດ</th>
                  <th style={{ borderBottom: 'none' }}>ຮູບ QR</th>
                  <th style={{ borderBottom: 'none' }}>ທະນາຄານ</th>
                  <th style={{ borderBottom: 'none' }}>ເລກບັນຊີ</th>
                  <th style={{ borderBottom: 'none' }}>ຊື່ບັນຊີ</th>
                  <th style={{ borderBottom: 'none' }}>ປະເພດບັດ</th>
                  <th style={{ borderBottom: 'none' }}>ສະກຸນເງິນ</th>
                  <th style={{ borderBottom: 'none' }}>ຈັດການ</th>
                </tr>
              </thead>
              <tbody >
                {
                  bankDatas?.length > 0 && bankDatas?.map((bank, index) => (
                    <tr key={bank?.id} style={{ whiteSpace: 'nowrap', opacity: bank?.isActiveDefault ? "1" : "0.5" }}>
                      <td>{index + 1}</td>
                      <td>
                        {
                          isEdited && selectedBankId === bank?.id ? <div className="col-sm-12 center" style={{ textAlign: "center" }}>
                            <input
                              type="file"
                              id="file-upload"
                              onChange={handleUpload}
                              hidden
                            />
                            <label htmlFor="file-upload">
                              <div
                                style={{
                                  background: "#E4E4E4E4",
                                  height: 60,
                                  width: 60,
                                  borderRadius: 8,
                                  cursor: "pointer",
                                  display: "flex",
                                }}
                              >
                                {file ? (
                                  <ImageThumb image={file} />
                                ) : (
                                  <div
                                    style={{
                                      height: 60,
                                      width: 60,
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {!bank?.image ? (
                                      <div
                                        style={{
                                          color: "#616161",
                                          fontSize: 20,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        +
                                      </div>
                                    ) : (
                                      <img
                                        src={S3_URL + bank?.image}
                                        style={{
                                          borderRadius: 8,
                                          height: 60,
                                          width: 60,
                                        }}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            </label>
                          </div> : <div
                            style={{
                              background: "#eee",
                              height: 60,
                              width: 60,
                              borderRadius: 8,
                              display: "flex",
                            }}
                          >
                            {isEdited && selectedBankId === bank?.id && file ? (
                              <ImageThumb image={file} />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  height: 60,
                                  width: 60,
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {!bank?.image ? (
                                  <p >
                                  </p>
                                ) : (
                                  <img
                                    src={S3_URL + bank?.image}
                                    style={{
                                      borderRadius: 8,
                                      height: 60,
                                      width: 60,
                                    }}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        }
                      </td>
                      {isEdited && selectedBankId === bank?.id ? <td>
                        <Form.Control
                          onChange={(e) => {
                            let _bankName = bankName;
                            _bankName = e.target.value;
                            setBankName(_bankName);
                          }}
                          type="text"
                          placeholder="ຊື່ທະນາຄານ..."
                          value={bankName || ""}
                        />
                      </td> : <td>{bank?.bankName}</td>}
                      {
                        isEdited && selectedBankId === bank?.id ? <td>
                          <Form.Control
                            onChange={(e) => {
                              let _bankAccount = bankAccount;
                              _bankAccount = e.target.value;
                              setBankAccount(_bankAccount);
                            }}
                            type="text"
                            placeholder="ເລກບັນຊີ..."
                            value={bankAccount || ""}
                          />
                        </td> : <td>{bank?.bankAccount}</td>
                      }
                      {isEdited && selectedBankId === bank?.id ?
                        <td>
                          <Form.Control
                            onChange={(e) => {
                              let _bankUser = bankUser;
                              _bankUser = e.target.value;
                              setBankUser(_bankUser);
                            }}
                            type="text"
                            placeholder="ຊື່ບັນຊີ..."
                            value={bankUser || ""}
                          />
                        </td> : <td>{bank?.isActiveDefault && <FaCheckSquare style={{ fontSize: 24 , color: 'green'}} /> } {bank?.bankUser}</td>}

                      {/* Payment Card Column */}
                      <td>{bank?.paymentCard || '-'}</td>

                      {/* Currency Column */}
                      <td>{bank?.currency || '-'}</td>


                      {
                        isEdited && selectedBankId === bank?.id ?
                          <td style={{ whiteSpace: 'nowrap' }}> <button
                            className="btn hoverme col-6 align-self-start"
                            onClick={_updateBank}
                            style={{
                              borderColor: COLOR_APP,
                              color: COLOR_APP
                            }}
                          >

                            {updateLoading ? <Spinner size="sm" animation="border" /> : (
                              <div><FontAwesomeIcon
                                icon={faSave}
                                style={{
                                  borderColor: COLOR_APP,
                                  color: COLOR_APP,
                                }}
                              /> ບັນທຶກ</div>)}
                          </button>
                            <button
                              className="btn hoverme col-6 ml-2"
                              style={{
                                borderColor: COLOR_APP_CANCEL,
                                color: COLOR_APP_CANCEL,
                              }}
                              onClick={() => {
                                setIsEdited(false);
                                setSelectedBankId("");
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                style={{ color: COLOR_APP_CANCEL }}
                              />
                              {" \t"}
                              ຍົກເລີກ
                            </button>
                          </td> :
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <button
                              className="btn hoverme"
                              onClick={() => {
                                setSelectedBankId(bank?.id);
                                setBankAccount(bank?.bankAccount || "");
                                setBankUser(bank?.bankUser || "");
                                
                                // Set bank code and name for editing
                                setSelectedBankCode(bank?.bankAbbv || ""); // bankName contains the code
                                setBankName(bankListV2[bank?.bankName] || bank?.bankName || "");
                                
                                // Set payment card and currency if available
                                setSelectedPaymentCard(bank?.paymentCard || "");
                                setSelectedCurrency(bank?.currency || "");
                                
                                // Set existing image URL
                                setExistingImageUrl(bank?.image || "");
                                
                                setShowEditModal(true);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faEdit}
                                style={{ color: COLOR_APP }}
                              />
                            </button>
                            <button
                              className="btn hoverme"
                              onClick={() => {
                                setSelectedBankId(bank?.id)
                                setShowDeleteModal(true);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                style={{ color: "red" }}
                              />
                            </button>
                          </td>
                      }
                    </tr>
                  ))
                }
              </tbody>
            </Table>
            {
              (bankDatas?.length <= 0 && !loading) && <EmptyComponent
                title={"ບໍ່ມີບັນຊີທະນາຄານເທື່ອ"}
                subTitle={
                  "ຈັດການບັນຊີທະນາຄານ ເພື່ອໃຫ້ລູກຄ້າສາມາດຈັດການການໂອນເງິນເຂົ້າບັນຊີຂອງທ່ານເພື່ອໃຫ້ງ່າຍ ແລະ ສະດວກຍິ່ງຂື້ນ."
                }
              // isButton={true}
              // buttonTitle={"ເພີ່ມສິນຄ້າ"}
              // buttonIcon={faPlusCircle}
              // buttonOnClick={_goProductAdd}
              />
            }
          </div>
        </div>
      </div>
      {width <= 700 &&
        <div style={{ marginLeft: 10, marginTop: 10 }} className="floating-container">
          <div style={{ marginLeft: 10, marginTop: 10 }} className="floating-button">
            <FontAwesomeIcon icon={faPlus} onClick={() => {
              _clearData();
              setShowAddModal(true);
            }} />
          </div>
        </div>}


      <BasicModal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          _clearData();
        }}
        okay={_deleteBank}
        title={"ທ່ານຕ້ອງການລຶບແທ້ບໍ?"}
        leftButtonName="ຍົກເລີກ"
        rightButtonName={deleteLoading ? <Spinner size="sm" animation="border" /> : "ຕົກລົງ"}
        Illustration={"images/Illustration.png"} />

      <Modal
        show={showAddModal}
        onHide={() => {
          setShowAddModal(false);
          _clearData();
        }}
        keyboard={false}
        size="md"
      >
        <Modal.Header
          style={{
            background: COLOR_APP,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 50,
            color: "#fff",
          }}
        >
          <h5>ເພີ່ມທະນາຄານ</h5>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            width: "100%",
          }}
        >
          <FormGroup>
            <Form.Label>ຊື່ທະນາຄານ</Form.Label>
            <Form.Select
              value={selectedBankCode || ""}
              onChange={(e) => onSelectBank(e.target.value)}
              className="mb-2"
            >
              <option value="">ເລືອກທະນາຄານ...</option>
              {Object.entries(bankListV2).map(([code, name]) => (
                <option key={code} value={code}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          <FormGroup>
            <Form.Label>
              ເລກບັນຊີ
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                setBankAccount(e.target.value);
              }}
              className="mb-2"
              type="text"
              placeholder="ເລກບັນຊີ..."
              value={bankAccount || ""}
            />
          </FormGroup>
          <FormGroup>
            <Form.Label>
              ຊື່ບັນຊີ
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                setBankUser(e.target.value);
              }}
              className="mb-2"
              type="text"
              placeholder="ຊື່ບັນຊີ..."
              value={bankUser || ""}
            />
          </FormGroup>
          <FormGroup>
            <Form.Label>
              ປະເພດບັດ
            </Form.Label>
            <Form.Select
              value={selectedPaymentCard || ""}
              onChange={(e) => onSelectPaymentCard(e.target.value)}
              className="mb-2"
            >
              <option value="">ເລືອກປະເພດບັດ...</option>
              {paymentCard.map((card) => (
                <option key={card} value={card}>
                  {card}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          <FormGroup>
            <Form.Label>
              ສະກຸນເງິນ
            </Form.Label>
            <Form.Select
              value={selectedCurrency || ""}
              onChange={(e) => setSelectedCurrency(e.target.value)}
              className="mb-2"
              disabled={selectedPaymentCard === 'VISA' || selectedPaymentCard === 'MASTERCARD'}
            >
              <option value="">ເລືອກສະກຸນເງິນ...</option>
              {currency.map((curr) => (
                <option key={curr} value={curr}>
                  {curr}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          <div className="col-sm-12 center" style={{ textAlign: "center" }}>
            <input
              type="file"
              id="file-upload"
              onChange={(e) => {
                handleUpload(e);
              }}
              hidden
            />
            <label htmlFor="file-upload">
              <div
                style={{
                  background: "#E4E4E4E4",
                  height: "150px",
                  width: "150px",
                  borderRadius: 8,
                  cursor: "pointer",
                  display: "flex",
                }}
              >
                 {file ? (
                   <ImageThumb image={file} height={150} widht={150} />
                 ) : existingImageUrl ? (
                   <img 
                     src={S3_URL + existingImageUrl} 
                     alt="Bank" 
                     style={{ 
                       height: "150px", 
                       width: "100%", 
                       objectFit: "cover",
                       borderRadius: "10px"
                     }} 
                   />
                 ) : (
                   <div
                     style={{
                       height: "100px",
                       width: "100%",
                       justifyContent: "center",
                       alignItems: "center",
                       color: "#fff",
                       fontSize: 100,
                       fontWeight: "bold",
                     }}
                   >
                     +
                   </div>
                 )}
               </div>
            </label>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={_createBank}
              style={{ width: "180px", marginRight: 10, background: COLOR_APP, fontWeight: 'bold' }}>
              {createLoading ? <Spinner size="sm" animation="border" /> : "ບັນທຶກ"}
            </Button>
            <Button
              onClick={() => {
                setShowAddModal(false);
                _clearData();
              }}
              style={{ width: "180px", border: '1px solid ' + COLOR_APP_CANCEL, background: 'transparent', color: COLOR_APP_CANCEL }}>
              ຍົກເລີກ
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Bank Modal */}
      <Modal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          _clearData();
        }}
        keyboard={false}
        size="md"
      >
        <Modal.Header
          style={{
            background: COLOR_APP,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 50,
            color: "#fff",
          }}
        >
          <h5>ແກ້ໄຂທະນາຄານ</h5>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <FormGroup>
            <Form.Label>ຊື່ທະນາຄານ</Form.Label>
            <Form.Select
              value={selectedBankCode || ""}
              onChange={(e) => onSelectBank(e.target.value)}
              className="mb-2"
            >
              <option value="">ເລືອກທະນາຄານ...</option>
              {Object.entries(bankListV2).map(([code, name]) => (
                <option key={code} value={code}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          <FormGroup>
            <Form.Label>ເລກບັນຊີ</Form.Label>
            <Form.Control
              type="text"
              value={bankAccount}
              onChange={(e) => setBankAccount(e.target.value)}
              placeholder="ກະລຸນາປ້ອນເລກບັນຊີ"
            />
          </FormGroup>
          <FormGroup>
            <Form.Label>ຊື່ເຈົ້າຂອງບັນຊີ</Form.Label>
            <Form.Control
              type="text"
              value={bankUser}
              onChange={(e) => setBankUser(e.target.value)}
              placeholder="ກະລຸນາປ້ອນຊື່ເຈົ້າຂອງບັນຊີ"
            />
          </FormGroup>
          <FormGroup>
            <Form.Label>ປະເພດບັດ</Form.Label>
            <Form.Select
              value={selectedPaymentCard || ""}
              onChange={(e) => onSelectPaymentCard(e.target.value)}
              className="mb-2"
            >
              <option value="">ເລືອກປະເພດບັດ...</option>
              {paymentCard.map((card) => (
                <option key={card} value={card}>
                  {card}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          <FormGroup>
            <Form.Label>ສະກຸນເງິນ</Form.Label>
            <Form.Select
              value={selectedCurrency || ""}
              onChange={(e) => setSelectedCurrency(e.target.value)}
              className="mb-2"
              disabled={selectedPaymentCard === 'VISA' || selectedPaymentCard === 'MASTERCARD'}
            >
              <option value="">ເລືອກສະກຸນເງິນ...</option>
              {currency.map((curr) => (
                <option key={curr} value={curr}>
                  {curr}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          <div style={{ marginBottom: 20 }}>
            <Form.Label>ຮູບພາບ</Form.Label>
            <input
              type="file"
              id="file-edit"
              style={{ display: "none" }}
              onChange={(e) => {
                setFile(e.target.files[0]);
                setFileName(e.target.files[0]?.name);
              }}
            />
            <label htmlFor="file-edit">
              <div
                style={{
                  height: "150px",
                  width: "100%",
                  border: "2px dashed #ccc",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: COLOR_APP,
                }}
              >
                {file ? (
                  <ImageThumb image={file} height={150} widht={150} />
                ) : existingImageUrl ? (
                    <img 
                      src={S3_URL + existingImageUrl} 
                      alt="Bank" 
                      style={{ 
                        height: "150px", 
                        width: "100%", 
                        objectFit: "cover",
                        borderRadius: "10px"
                      }} 
                    />
                  ) : (
                  <div
                    style={{
                      height: "100px",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                      fontSize: 100,
                      fontWeight: "bold",
                    }}
                  >
                    +
                  </div>
                )}
              </div>
            </label>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={_updateBank}
              style={{ width: "180px", marginRight: 10, background: COLOR_APP, fontWeight: 'bold' }}>
              {updateLoading ? <Spinner size="sm" animation="border" /> : "ອັບເດດ"}
            </Button>
            <Button
              onClick={() => {
                setShowEditModal(false);
                _clearData();
              }}
              style={{ width: "180px", border: '1px solid ' + COLOR_APP_CANCEL, background: 'transparent', color: COLOR_APP_CANCEL }}>
              ຍົກເລີກ
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* set default account bank */}
      <Modal centered show={isDefaultModal} onHide={handleCloseModalSetdefault}>
        <Modal.Body>
          <BankAccountActive onCloseModal={handleCloseModalSetdefault} fetchNewDataBank={_getBank} />
        </Modal.Body>
      </Modal>

    </div >
  );
}

export default SettingsBank;
